import './../../scss/blocks/_topics.scss'

import { goAnim } from './../utils/goAnim'

document.addEventListener('DOMContentLoaded', () => {
    const animatedElementsClass = 'animated'
    goAnim(animatedElementsClass)
})
